import { setEditor } from 'reactApp/modules/editor/editor.saga';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { watchFreezeUser } from 'reactApp/modules/freeze/freeze.saga';
import { setTree } from 'reactApp/modules/home/home.saga';
import { showExpiredDeviceSubscription, showOverquotaPopup } from 'reactApp/modules/home/sagas/popups.saga';
import { watchFbUser } from 'reactApp/modules/recovery/fbRecovery.saga';
import { isLandingPage } from 'reactApp/modules/router/router.selectors';
import { initConsoleApi, reportFeatures, setQueryParams } from 'reactApp/modules/settings/settings.saga';
import { SettingsSelectors } from 'reactApp/modules/settings/settings.selectors';
import { socialUserConfirmEmail } from 'reactApp/modules/socialUser/socialUser.saga';
import { initSortSaga } from 'reactApp/modules/sort/sort.saga';
import { checkContinueUpload } from 'reactApp/modules/uploadList/continueUpload/continueUpload.saga';
import { call, fork, select } from 'redux-saga/effects';

export function* initSagas() {
    yield fork(watchFbUser);
    yield fork(watchFreezeUser);
    yield call(setQueryParams);
    yield call(setEditor);
    yield call(setTree);
    yield call(initSortSaga); // TODO: routing: now it is for home only
    yield call(checkContinueUpload);
    yield fork(socialUserConfirmEmail);
    yield call(initConsoleApi);
    yield call(reportFeatures);

    // вынести в отдельную инит сагу для тачей
    const { action: queryParam } = yield select(SettingsSelectors.getQueryParams);
    const isPhone = yield select(EnvironmentSelectors.isPhone);
    const isWebview = yield select(EnvironmentSelectors.isWebview);
    const isLP = isLandingPage();

    if (isPhone && !isWebview && queryParam !== 'request-payment' && !isLP) {
        yield fork(showExpiredDeviceSubscription);
        yield fork(showOverquotaPopup);
    }
}
